import { render, staticRenderFns } from "./ConsultExam.vue?vue&type=template&id=01fb6425&scoped=true&"
import script from "./ConsultExam.vue?vue&type=script&lang=js&"
export * from "./ConsultExam.vue?vue&type=script&lang=js&"
import style0 from "./ConsultExam.vue?vue&type=style&index=0&id=01fb6425&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fb6425",
  null
  
)

export default component.exports